export enum UploadBoxType {
  Email = "email",
  Other = "other",
}
